module.exports = "<div class=\"input-group\">\r\n  <input type=\"text\" id=\"filterText\" class=\"form-control\" placeholder=\"{{ 'FILTER.SEARCH' | translate }}\" [value]=\"currentFilterText | async\" (keyup)=\"filterTextChanged($event)\">\r\n  <div class=\"input-group-btn\">\r\n    <button class=\"btn btn-default\" type=\"submit\" disabled><i class=\"glyphicon glyphicon-search\"></i></button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/filter-text/filter-text.component.html
// module id = ../../../../../src/app/shared/filter-text/filter-text.component.html
// module chunks = 16